export default function DischargeIndicator({ width = 14, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width={width} height={height} rx='2' fill='#3253EF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.13792 4.19927L7.34946 4.63677V9.09927H8.39946V8.57427H9.09946V9.79927H7.34946V10.4993L4.19946 9.36177V3.49927H9.09946V4.72427H8.39946V4.19927H6.13792ZM9.79946 8.04927L9.30946 7.55927L9.86071 6.99927H7.69946V6.29927H9.86071L9.30946 5.73927L9.79946 5.24927L11.1995 6.64927L9.79946 8.04927Z'
        fill='white'
      />
    </svg>
  );
}
